<template>

  <div id="xx">

    <!-- Filters -->
    <geofence-list-filters :owners-filter.sync="ownersFilter" :group-filter.sync="groupFilter"
      :type-filter.sync="typeFilter" :contracts-filter.sync="contractsFilter" :categories-filter.sync="categoriesFilter"
      :owners-options="filterOptions.owners || []" :category-options="filterOptions.categories || []"
      :contract-options="filterOptions.contracts || []" :group-options="filterOptions.groups || []"
      :type-options="filterOptions.types || []" :devices-options="[]">
    </geofence-list-filters>


    <!-- Table Container Card -->
    <b-card no-body class="mb-0">

      <div class="loading_page" v-if="requestStatus">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
      </div>

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <label>{{ $t('Show') }}</label>
            <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="perPageOptions"
              :clearable="false" class="per-page-selector d-inline-block mx-50" />
            <label>{{ $t('entries') }}</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input v-model="searchQuery" class="d-inline-block mr-1" placeholder="Search..." />
              <b-button v-if="$store.state.auth.userData.permissions.includes('geofence.create')" variant="primary"
                :to="{ name: 'geofence.create' }">
                <span class="text-nowrap">{{ $t('Add Geofence') }}</span>
              </b-button>
              <div v-if="$store.state.auth.userData.roles.includes($roles.SUPER_ADMIN)">
                <input type="file" hidden ref="importFileInput" @input="importFile"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />

                <b-button class="mr-1 ml-1" variant="info" @click="$refs.importFileInput.click()">
                  <span class="text-nowrap">{{ $t('Import') }}</span>
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table ref="refGeofenceListTable" class="position-relative" :items="fetchGeofence" responsive
        :fields="tableColumns" primary-key="id" :sort-by.sync="sortBy" show-empty
        :empty-text="$t('No matching records found')" :sort-desc.sync="isSortDirDesc">

        <!-- Column: id -->
        <template #cell(id)="data">
          <b-media vertical-align="center">
            {{ data.index + 1 }}
          </b-media>
        </template>


        <!-- Column: name -->
        <template #cell(name)="data">
          <b-media vertical-align="center">
            {{ data.item.name }}
          </b-media>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown class="actionIcon" variant="link" no-caret :right="$store.state.appConfig.isRTL">
            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
            </template>
            <b-dropdown-item v-if="$store.getters['auth/menus'].includes('geofence.edit')"
              :to="{ name: 'geofence.edit', params: { id: data.item.id } }">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">{{ $t('Edit') }}</span>
            </b-dropdown-item>

            <b-dropdown-item v-else>
              <span class="align-middle ml-50">{{ $t('Edit Geofence Not Permitted') }}</span>
            </b-dropdown-item>

            <b-dropdown-item @click="removeGeofence(data.item.id)"
              v-if="$store.getters['auth/menus'].includes('geofence.destroy')">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">{{ $t('Delete') }}</span>
            </b-dropdown-item>

          </b-dropdown>
        </template>

      </b-table>

      <div class="mx-2 mb-2">
        <b-row>

          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
            <span class="text-muted">{{ $t('Showing') }} {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }}
              {{ $t('entries') }}</span>
          </b-col>
          <!-- Pagination -->
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">

            <b-pagination v-model="currentPage" :total-rows="totalGeofence" :per-page="perPage" first-number last-number
              class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>

import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted, watch, onMounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'

import useGeofenceList from '@/views/modules/geofence/geofence-list/useGeofenceList'
import geofenceStoreModule from '@/views/modules/geofence/geofenceStoreModule'
import GeofenceListFilters from '@/views/modules/geofence/geofence-list/GeofenceListFilters'
import { OrbitSpinner } from 'epic-spinners'

import useHelpers from '@/views/modules/useHelpers'


export default {
  components: {
    GeofenceListFilters,
    OrbitSpinner,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,

    vSelect,
  },
  setup(props, { root }) {

    const GEOFENCE_APP_STORE_MODULE_NAME = 'app-geofence'

    // Register module
    if (!store.hasModule(GEOFENCE_APP_STORE_MODULE_NAME))
      store.registerModule(GEOFENCE_APP_STORE_MODULE_NAME, geofenceStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(GEOFENCE_APP_STORE_MODULE_NAME))
        store.unregisterModule(GEOFENCE_APP_STORE_MODULE_NAME)
    })





    const importFileInput = ref(null)

    const importFile = () => {

      const form = new FormData()

      form.append('file', importFileInput.value.files[0])

      store.dispatch('app-geofence/importFile', form)
        .then(res => { }).catch(reason => console.log(reason))

      importFileInput.value = null
    }

    const { fetchGeofence, deleteRow,
      geofences, tableColumns, perPage, currentPage, totalGeofence,
      dataMeta, perPageOptions, searchQuery, sortBy, isSortDirDesc,
      refGeofenceListTable, refetchData, ownersFilter, contractsFilter,
      groupFilter, typeFilter, categoriesFilter, filterOptions,
      requestStatus } = useGeofenceList()

    const filterOrigOptions = ref({})
    store.dispatch('app-geofence/getFilterBy',
      { user: store.getters['auth/user'].id, 'type': 'geofence' })
      .then(res => {
        filterOptions.value = res.data.data;
        filterOrigOptions.value =JSON.parse(JSON.stringify(res.data.data));
      }).catch(reason => { })
    ///// Refilter contract by Owner //
    const refliterContractByWoners = (owners) => {
      const result = filterOrigOptions.value.contracts.filter((i) => owners.includes(i.contractor_id));
      filterOptions.value.contracts = result;
      if (owners.length == 0) {
        filterOptions.value = JSON.parse(JSON.stringify(filterOrigOptions.value));
       
      }
    }
    watch([ownersFilter], () => { refliterContractByWoners(ownersFilter.value) })
    ////end/////

    const { confirm, toaster } = useHelpers(root)

    const delete_geofence = id => {
      confirm(id, _ => {
        deleteRow(id, () => {
          refGeofenceListTable.value.refresh()
          toaster('Geofence deleted successfully')
        })
      })
    }



    const removeGeofence = (id) => {
      root.$swal({
        title: root.$i18n.t("Are You Sure"),
        text: root.$i18n.t("Do you want to delete this geofence?"),
        showCancelButton: true,
        confirmButtonText: root.$i18n.t('Delete'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          requestStatus.value = true

          store.dispatch('app-geofence/deleteGeofence', id)
            .then(_ => {
              toaster('Geofence Deleted Successfully')
              refetchData()
            })
            .catch(reason => {
              requestStatus.value = false
              toaster(root.$i18n.t(reason.response.data.error), 'danger', root.$i18n.t('Error'))


            })
        }
      })
    }


    return {
      importFile,
      importFileInput,

      delete_geofence,
      removeGeofence,

      requestStatus, fetchGeofence, tableColumns, perPage,
      currentPage, totalGeofence,
      dataMeta, perPageOptions, searchQuery, sortBy, isSortDirDesc,
      refGeofenceListTable, refetchData, filterOptions,

      ownersFilter,
      categoriesFilter,
      typeFilter,
      groupFilter,
      contractsFilter,

      // Filter
      avatarText,

    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.actionIcon>button {
  padding: 0;
}
</style>
